import React from 'react';
import { ArrowRight, PawPrint } from 'lucide-react';
import { Badge, Button } from './ui';
type HeroProps = {
  onPurchaseRequest?: () => void;
};
export function Hero({
  onPurchaseRequest
}: HeroProps) {
  const scrollToPurchase = () => {
    const purchaseSection = document.getElementById('planes');
    if (purchaseSection) {
      purchaseSection.scrollIntoView({
        behavior: 'smooth'
      });
      return;
    }
    onPurchaseRequest?.();
  };
  return <section className="relative pt-4 pb-16 md:pt-6 md:pb-24 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-14" data-mp="1274nzp1vrg78">
      {/* Background glow */}
      <div className="hero-background-glow absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-15" data-mp="sartioyigybf"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-16" data-mp="3d21rzwjzqin7">
        <div className="inline-flex items-center gap-2 mb-4" data-id="element-17" data-mp="3cz5to748dry8">
          <PawPrint className="w-6 h-6 text-brand-400" aria-hidden="true" data-id="element-18" data-mp="381nw1cvnyz5j" />
          <span className="text-brand-400 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-19" data-mp="3j896f9neq5ny">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="md:text-[52px] font-black text-white mb-4 tracking-tight text-[23px]" data-id="element-20" data-mp="3o59dnnvztegn">
          ¿Tu cachorro hace pis dentro de casa, muerde todo o
          <br data-id="element-21" data-mp="3e8ecex8c4zyo" />
          <span className="text-brand-400 text-glow" data-id="element-22" data-mp="3e7uxlpdzerov">
            no te deja descansar?
          </span>
        </h1>

        <div className="relative mt-4 mb-6 flex justify-center" data-id="element-23" data-mp="30fya5yn9d5yt">
          <div className="hero-product-glow absolute inset-0 bg-brand-500/20 blur-[80px] rounded-full pointer-events-none" data-id="element-24" data-mp="359jahxcbqc16"></div>
          <img src="https://cdn.magicpatterns.com/uploads/28yrsyxoB7sEAXPvD5ECj1/mockup_final.png" alt="Punto Digital: kit completo para criar a tu cachorro, con seis tomos y bonos incluidos" className="hero-mockup relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-25" data-mp="2qhqudj4pgtye" />
        </div>

        <p className="text-slate-400 max-w-2xl mx-auto text-[14px] mt-[3px] mb-[3px]" data-id="element-26" data-mp="na08cwk1yzd4">
          No importa cuál sea el problema que hoy tenga tu cachorro. Este Kit
          Completo incluye un método específico para resolver cada uno de los
          desafíos más comunes durante los primeros meses. Aprendé exactamente
          qué hacer, cuándo hacerlo y cómo evitar los errores que hacen que esos
          problemas se repitan.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-8 overflow-x-auto" data-id="element-27" data-mp="1126owjr4b8d3">
          <Badge className="whitespace-nowrap" data-id="element-28" data-mp="x14ldqq64a5b">✅ 100% Digital</Badge>
          <Badge className="whitespace-nowrap" data-id="element-29" data-mp="x0ut1whnhqwg">⚡ Acceso inmediato</Badge>
          <Badge className="whitespace-nowrap" data-id="element-30" data-mp="3ltqeji9dp5w5">🐶 6 Tomos + 5 Bonos</Badge>
        </div>

        <div className="flex flex-col items-center gap-6" data-id="element-31" data-mp="3hqaian1817jz">
          <Button size="md" className="w-full md:w-auto group" onClick={scrollToPurchase} data-id="element-32" data-mp="1x9b590wn91ck">
            <span className="group-hover:scale-110 transition-transform" data-id="element-33" data-mp="21bxyn68yqubv">
              🐾 SÍ, QUIERO EDUCAR BIEN A MI CACHORRO
            </span>
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-34" data-mp="2686aoarv67et" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-slate-400" data-id="element-35" data-mp="2g02l8lb4zpzx">
            <span className="flex items-center" data-id="element-36" data-mp="2kyn9dmd46j80">🛡️ Garantía 7 días</span>
            <span className="flex items-center" data-id="element-37" data-mp="2l100oq4ri5xq">🔒 Pago seguro</span>
            <span className="flex items-center" data-id="element-38" data-mp="2p1sapllgkev2">⚡ Acceso inmediato</span>
          </div>
        </div>
      </div>
    </section>;
}